import { render, staticRenderFns } from "./ResepOptik.vue?vue&type=template&id=14c59ac4&"
import script from "./ResepOptik.vue?vue&type=script&lang=js&"
export * from "./ResepOptik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports